import { Component, Input, OnInit } from '@angular/core';
import { FilterDefinition } from '@model';

@Component({
    template: '',
    standalone: false
})
export abstract class BaseFilterComponent {
  @Input()
  filter: FilterDefinition;
  public componentName: string;
}
